import { SvrAPk } from "../../utils/axios/index";
/**
 *
 */
export const getDispensaActivos = async () => {
    let res = {};
    try {
      res = await SvrAPk.get("/api/public/dispensa/getdispensaactivo");
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
 *
 **/ 
export const ValidarDispensador = async (DispensaId, CodigoVinc) => {
    let res = {};
    try {
      res = await SvrAPk.post("/api/public/dispensa/getvalidardispensador",{DispensaId, CodigoVinc});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
//----------------------------------------------------- 
export const getVerficaDispensador = async (DispensaId, ClientAPKey ,CodigoVinc) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/dispensa/getverificadispensador",{DispensaId, ClientAPKey, CodigoVinc});
  } catch (Error) {
    res = Error;
  }
  return res;
};
//-------------------------------------------------------
export const getdispensadorarea = async (DispensaId) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/dispensa/getdispensadorarea",{DispensaId});
  } catch (Error) {
    res = Error;
  }
  return res;
};
